// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../../../../../services/api';

const ordersService = async (data) => {
  return api(`/Sellitback.svc/GetMyShipments?Token=${data.token}&CustomerId=${data.id}`,
    {}, 'GET');
};

export default ordersService;
